export const can = (user, permission) => {
  if (!user?.permissions) return true;
  if (user.is_impersonating && user.read_only_disabled_permissions?.includes(permission)) return false;
  return user.permissions.includes(permission);
};

export const permissionDeniedMessage = "Bu işlem için rol yetkiniz yok.";